import { useState } from "react";
import ReactPaginate from "react-paginate";
import "./Paginate.css";

const Paginate = ({ pageNumber, itemsPerPage, pageCount, onPageChange }) => {
  const [_, setItemOffset] = useState(0);
  const [skipPageNumber, setSkipPageNumber] = useState(0);

  const handlePageClick = (event) => {
    const apiPage = event.selected + 1;
    const newOffset = event.selected * itemsPerPage;

    setItemOffset(newOffset);
    onPageChange(apiPage);
  };

  const skipToPageHandler = () => {
    const newOffset = skipPageNumber * itemsPerPage;
    setItemOffset(newOffset);
    onPageChange(Number(skipPageNumber));
  };

  return (
    <div className="pagination-container">
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        previousLabel="<"
        renderOnZeroPageCount={null}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        pageCount={pageCount}
        initialPage={0}
        forcePage={pageNumber - 1}
        containerClassName="pagination"
        pageLinkClassName="page-num"
        previousLinkClassName="page-num"
        nextLinkClassName="page-num"
        activeLinkClassName="active"
        breakClassName="paginationBreak"
      />

      <label htmlFor="page-number" className="paginate-label">
        <span onClick={skipToPageHandler} className="paginate-tag">
          Go To
        </span>
        <input
          type="input"
          name="page-number"
          id="page-number"
          className="paginate-input"
          onChange={(e) => setSkipPageNumber(e.target.value)}
        />
      </label>
    </div>
  );
};

export default Paginate;
